import { render, staticRenderFns } from "./CardBySide5.vue?vue&type=template&id=68e90ed0&scoped=true&"
import script from "./CardBySide5.vue?vue&type=script&lang=js&"
export * from "./CardBySide5.vue?vue&type=script&lang=js&"
import style0 from "./CardBySide5.vue?vue&type=style&index=0&id=68e90ed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e90ed0",
  null
  
)

export default component.exports